import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import useB4BreakPoints from 'src/hooks/useB4BreakPoints';
import { UrlImagenes } from 'src/parametros';

const NavbarHeader = ({ logoAseguradora = "", logoComercial = "", showBack = true, goBack = '' }) => {

  const cotizacion: any = useSelector<any>((state) => state.Cotizacion.cotizacion);
  const { isMd } = useB4BreakPoints();

  const history = useHistory();
  const onClickGoBack = () => history.push(goBack);

  return (
    <header className="navbar__header sticky-top bg-white">
      <div className="row justify-content-center py-3">
        <div className="col-12 col-md-10 col-lg-7 ml-2 ml-md-4 align-self-center">
          <div className="d-flex flex-row justify-content-between ">
            <div>

              {showBack && (
                <button
                  type="button"
                  className="navbar__header__back__button mr-2 mt-2"
                  style={{
                    backgroundColor: 'white',
                    border: 'none',
                    outline: 'none',
                  }}
                  onClick={onClickGoBack}
                >
                  <i className="pi pi-arrow-left mt-auto" style={{ fontSize: '20px' }} />
                </button>
              )}
              {(logoAseguradora || (cotizacion?.tieneHeader && cotizacion?.tieneAseguradora)) && (
                <img
                  style={{ height: isMd ? 50 : 40 }}
                  className="mr-auto"
                  src={UrlImagenes + (logoAseguradora || cotizacion?.aseguradora?.urlLogo)}
                  alt="ASEGURADORA"
                />
              )}

            </div>
            {(logoComercial || (cotizacion?.tieneHeader && cotizacion?.tieneCanalComercial)) && (
              <img
                className="ml-auto"
                style={{ height: isMd ? 50 : 40 }}
                src={UrlImagenes + (logoComercial || cotizacion?.canalComercial?.urlLogo)}
                alt="CANAL_COMERCIAL"
              />
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default NavbarHeader;
